import { css } from '@linaria/core';
import { ellipsis } from 'polished';
import { baseTheme, breakpoints } from 'styles/utils';
export const selectWrapper = "odules__Home__CodeSnippet__dropdown__Dropdown_styles_ts-selectWrapper-s1mp3d1d";
export const selectWrapperForCodeSnippet = "odules__Home__CodeSnippet__dropdown__Dropdown_styles_ts-selectWrapperForCodeSnippet-spziux6";
export const popupMenu = "odules__Home__CodeSnippet__dropdown__Dropdown_styles_ts-popupMenu-p79fgbl";

require("./Dropdown.styles.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Dropdown.styles.ts");